<template>
    <div class="root_page_center wrapper_setting">
        <div class="frm_setting">
            <form action="" method="post" id="frm_st" @submit="sendBusiness($event)">
                <h2 class="titleFrm_setting">Thông tin doanh nghiệp</h2>
                <div class="input_setting">
                    <label>Tên công ty</label>
                    <!-- <input type="text" v-model="company_name" placeholder="Tên công ty"> -->
                    <textarea v-model="company_name" rows="2" placeholder="Tên công ty"></textarea>
                </div>
                <div class="input_setting">
                    <label>Mã số thuế</label>
                    <input type="text" v-model="taxCode" placeholder="Mã số thuế">
                </div>
                <div class="input_setting">
                    <label>Người đại diện</label>
                    <input type="text" v-model="staff" placeholder="Người đại diện">
                </div>
                <div class="input_setting">
                    <label>Địa chỉ trụ sở</label>
                    <!-- <input type="text" v-model="address" placeholder="Địa chỉ trụ sở"> -->
                    <textarea v-model="address" rows="2" placeholder="Địa chỉ trụ sở"></textarea>
                </div>
                <div class="input_setting">
                    <label>Số điện thoại</label>
                    <input type="text" v-model="phone" placeholder="Số điện thoại">
                </div>
                <div class="input_setting">
                    <label>Vốn điều lệ</label>
                    <input type="text" v-model="showMoney" @input="onNumberInput" ref="input_amount" placeholder="Vốn điều lệ">
                </div>
                <div class="input_setting">
                    <label>Ngày thành lập</label>
                    <input type="text" maxlength="10" v-model="ngaythanhlap" @input="handleDateInput($event, 'ngaythanhlap')" placeholder="Ngày thành lập">
                </div>
                <div class="input_setting">
                    <label>Ngành nghề chính</label>
                    <input type="text" v-model="job" placeholder="Ngành nghề chính">
                </div>
                <div class="input_setting input_settingVselect">
                    <label>Tên ngân hàng</label>
                    <v-select
                        v-model="bankname"
                        :options="listBank"
                        label="name"
                        :reduce="bank => bank.id"
                        placeholder="Chọn ngân hàng"
                    >
                        <template #option="{ name, image }">
                            <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                            {{ name }}
                        </template>
                        <template #selected-option="{ name, image }">
                            <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                            {{ name }}
                        </template>
                    </v-select>
                </div>
                <div class="input_setting">
                    <label>Số tài khoản</label>
                    <!--  @blur="handleBlurBank()" -->
                    <input type="text" v-model="banknumber" placeholder="Số tài khoản">
                </div>
                <div class="input_setting" style="display:none !important;">
                    <label>Loại hình doanh nghiệp</label>
                    <select v-model="companyType">
                        <option value="" selected="selected">Loại hình doanh nghiệp</option>
                        <option :value="item.id" v-for="(item, index) in listCompany" :key="index">{{  item.name }}</option>
                    </select>
                </div>
                <div class="input_setting">
                    <label>Cán bộ quản lý</label>
                    <input type="text" v-model="management" placeholder="Cán bộ quản lý">
                </div>
                <div class="input_setting">
                    <label>Email</label>
                    <input type="email" v-model="email" placeholder="Email">
                </div>
                <h3 class="titleFrm_setting titleFrm_settings">Thông tin chủ doanh nghiệp</h3>
                <div class="input_setting">
                    <label>Họ và tên</label>
                    <input type="text" v-model="fullname" placeholder="Họ và tên">
                </div>
                <div class="input_setting">
                    <label>Ngày tháng năm sinh</label>
                    <input type="text" maxlength="10" v-model="ngaysinh" @input="handleDateInput($event, 'ngaysinh')" placeholder="Ngày sinh">
                </div>
                <div class="input_setting">
                    <label>Số CMND / CCCD</label>
                    <input type="text" v-model="identity_number" placeholder="Số CMND / CCCD">
                </div>
                <div class="input_setting">
                    <label>Giới tính</label>
                    <select v-model="sex">
                        <option value="" selected>Giới tính</option>
                        <option value="Nam">Nam</option>
                        <option value="Nữ">Nữ</option>
                    </select>
                </div>
                <div class="input_setting">
                    <label>Quốc tịch</label>
                    <input type="text" v-model="nationality" placeholder="Quốc tịch">
                </div>
                <div class="input_setting">
                    <label>Nơi thường trú</label>
                    <input type="text" v-model="residence" placeholder="Nơi thường trú">
                </div>
                <div class="input_setting">
                    <label>Ngày cấp</label>
                    <input type="text" maxlength="10" v-model="ngaycap" @input="handleDateInput($event, 'ngaycap')" placeholder="Ngày cấp">
                </div>
                <div class="input_setting">
                    <label>Nơi cấp</label>
                    <!-- <input type="text" v-model="placeIssue" placeholder="Nơi cấp"> -->
                    <textarea v-model="placeIssue" rows="2" placeholder="Nơi cấp"></textarea>
                </div>
                <div class="btn_setting">
                    <button type="submit">Cập nhật hồ sơ</button>
                </div>
            </form>
        </div>
        <!-- modal -->
        <!-- <div class="modalRedirect modal_register_success" v-if="showmodal">
            <div class="content_modalredirect content_modalredirectHds">
                <p @click="showmodal = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodal = false" alt=""></p>
                <div class="wrp_modal_type" v-if="type == 'thong_bao'">
                    <h6 v-html="content_tb"></h6>
                    <div class="btnxn_modal">
                        <router-link to="/loading">Tiếp tục</router-link>
                    </div>
                </div>
                <div class="wrp_modal_type" v-else-if="type == 'qr'">
                    <img :src="linkWebAdmin + content_tb" alt="" v-if="content_tb != null">
                    <h6 v-else>mã QR chưa cập nhật</h6>
                </div>
                <div class="wrp_modal_type" v-else>
                    <img src="../assets/images/dd.png" alt="">
                    <div class="btnxn_modal">
                        <router-link to="/identifier">Định danh</router-link>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import viCustom from '@/locales/vi-custom'
import SocketIO from 'socket.io-client'
export default {
    name: 'Setting_tool',
    data () {
        return {
            vi: viCustom,
            token: window.localStorage.getItem('token'),
            company_name: '',
            taxCode: '',
            staff: '',
            address: '',
            phone: '',
            money: '',
            showMoney: '',
            ngaythanhlap: '',
            job: '',
            management: '',
            email: '',
            bankname: null,
            banknumber: '',
            companyType: '',
            fullname: '',
            ngaysinh: '',
            identity_number: '',
            sex: '',
            nationality: '',
            residence: '',
            ngaycap: '',
            placeIssue: '',

            listCompany: [],
            format: 'dd/MM/yyyy',
            listBank: [],
            socket: null,
            orther: [],

            showmodal: false,
            type: '',
            content_tb: '',
        }
    },
    components: {
        vSelect
    },
    mounted () {
        
    },
    created () {
        this.getCompany()
        this.getDataListInfo()
        this.getDataListInfoSetting()
        this.getListBank()
        this.socketEventSetting()
    },
    computed: {
        
    },
    beforeUnmount () {
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        getListBank () {
            this.axios.get(this.api_logoBanks).then((response) => {
                this.listBank = response.data.data
            })
        },
        getCompany () {
            this.axios.get(this.api_getCompany).then((response) => {
                this.listCompany = response.data.data
            })
        },
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.fullname = response.data.data.name
                this.bankname = response.data.data.bank_id == 0 ? null : Number(response.data.data.bank_id);
                this.companyType = Number(response.data.data.company_type)
                this.taxCode = response.data.data.tax_code
                if(response.data.data.dob == null){
                    this.ngaysinh = ''
                }else{
                    this.ngaysinh = response.data.data.dob.split('-').reverse().join('-');
                }
                this.identity_number = response.data.data.identity_number
                this.sex = response.data.data.gender
                this.nationality = response.data.data.nationality
                this.residence = response.data.data.permanent_address
                this.email = response.data.data.email
                if(response.data.data.issue_date == null){
                    this.ngaycap = ''
                }else{
                    this.ngaycap = response.data.data.issue_date.split('-').reverse().join('-');
                }
                this.placeIssue = response.data.data.issue_place
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getDataListInfoSetting () {
            this.axios.get(this.api_getBusiness,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                if(response.data.data != null){
                    this.company_name = response.data.data.company_name
                    this.staff = response.data.data.representative_name
                    this.address = response.data.data.head_office_address
                    this.phone = response.data.data.phone_number
                    this.money = response.data.data.charter_capital
                    this.showMoney = this.formatNumber(String(this.money))
                    if(response.data.data.establishment_date == null){
                        this.ngaythanhlap = ''
                    }else{
                        this.ngaythanhlap = response.data.data.establishment_date.split('-').reverse().join('-');
                    }
                    this.job = response.data.data.main_business_line
                    this.management = response.data.data.staff_name
                    this.banknumber = response.data.data.bank_account_number
                }
            })
        },
        sendBusiness (e){
            e.preventDefault()
            this.axios.post(this.api_postBusiness, 
                {
                    company_name: this.company_name,
                    tax_code: this.taxCode,
                    representative_name: this.staff,
                    head_office_address: this.address,
                    phone_number: this.phone,
                    charter_capital: this.money,
                    establishment_date: this.formatToApiDate(this.ngaythanhlap),
                    main_business_line: this.job,
                    staff_name: this.management,
                    email: this.email,
                    bank_name: this.bankname,
                    bank_account_number: this.banknumber,
                    business_type: this.companyType,
                    name: this.fullname,
                    dob: this.formatToApiDate(this.ngaysinh),
                    identity_number: this.identity_number,
                    gender: this.sex,
                    nationality: this.nationality,
                    permanent_address: this.residence,
                    issue_date: this.formatToApiDate(this.ngaycap),
                    issue_place: this.placeIssue,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                // this.type = response.data.completion_type
                this.content_tb = response.data.dialog
                // this.showmodal = true
                this.$router.push('/loading')
            }).catch(e => {
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.errors,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        },
        formatDate(date) {
            if (!date) return ''
            const yyyy = date.getFullYear()
            const dd = String(date.getDate()).padStart(2, '0')
            const mm = String(date.getMonth() + 1).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        formatNumber(value) {
            const cleaned = value.split('.')[0];
            const num = cleaned.replace(/\D/g, '');
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        onNumberInput(e) {
            // const raw = e.target.value.replace(/,/g, '');
            const raw = e.target.value.replace(/\./g, '');
            this.money = raw
            this.showMoney = this.formatNumber(raw);
        },
        socketEventSetting () {
            let thiss = this
            var idUser = window.localStorage.getItem('idUser')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_load-business.${idUser}:ReloadEvent`, function(result) {
                // console.log('2222', result.data);
                if(result.data.load_business == true){
                    thiss.getDataListInfo()
                    thiss.getDataListInfoSetting()
                }
            });
        },
        handleBlurBank() {
            this.axios.post(this.api_updateBankNumber, 
                {
                    bank_name: this.bankname,
                    bank_account_number: this.banknumber,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.orther = response
            })
        },
        onOpen() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const currentYear = new Date().getFullYear()
                    const yearEl = [...document.querySelectorAll('.dp__overlay_cell')].find(el => el.textContent.trim() == currentYear)
                    if (!yearEl) {
                        console.log('Không tìm thấy năm', currentYear)
                        return
                    }
                    let container = yearEl.parentElement
                    while (container) {
                        if (container.scrollHeight > container.clientHeight) {
                            break
                        }
                        container = container.parentElement
                    }
                    if (container) {
                        container.scrollTop =
                            yearEl.offsetTop - container.clientHeight / 2
                    }
                }, 100)
            })
        },
        handleDateInput(event, fieldName) {
            let value = event.target.value.replace(/\D/g, '');
            if (value.length > 8) {
                value = value.slice(0, 8);
            }
            let formatted = '';
            if (value.length > 0) {
                formatted += value.substr(0, 2);
            }
            if (value.length > 2) {
                formatted += '-' + value.substr(2, 2);
            }
            if (value.length > 4) {
                formatted += '-' + value.substr(4, 4);
            }
            if (fieldName && fieldName in this) {
                this[fieldName] = formatted;
            }
            event.target.value = formatted;
        },
        formatToApiDate(dateStr) {
            if (!dateStr || dateStr.length < 10) return '';
            const [day, month, year] = dateStr.split('-');
            return `${year}/${month}/${day}`; 
        }
    }
}
</script>